import React, {useState,useEffect} from "react";
import stilePulsanti from "../../../interfaccia/stilePulsanti";
import associaImmagineENomeANomeUtente from "../../../interfaccia/funzioniComuni/associaImmagineENomeANomeUtente";
import axios from "axios";
import apiUrl from "../../../Apiurl";

function Nota({nota, utente, handleChange, className, i, rimuoviDaArr, tabellaNote, token, arrLength, onSalvaNota, onEliminaNota, rimuoviBozza, canScrivereNote }) {
    
    //console.log("nota", nota)
    const {pathImmagine, nomeDisplay} = associaImmagineENomeANomeUtente(nota.nomeUtente, utente.username)
    const [conferma,setConferma] = useState(false)
    const [alertSalvataggio, setAlertSalvataggio] = useState(false)
    const canUpdateLogistica = Boolean(utente?.permessiAPI?.["update:logistica"])
    const [salvataggioInCorso, setSalvataggioInCorso] = useState(false)
    const notaModificabile = utente.username === nota.nomeUtente && i+1 === (arrLength || 1)
    const bozzaNota = !nota.id && Boolean(rimuoviBozza)
    const mostraSalvaNota = Boolean(onSalvaNota) && canScrivereNote && notaModificabile && (nota.daSalvare || !nota.id)
    const notaPropria = Boolean(nota.id) && utente.username === nota.nomeUtente && Boolean(onEliminaNota)
    const puoEliminare = canUpdateLogistica || (canScrivereNote && (bozzaNota || notaPropria))

    const salvaNota = async function() {
        setSalvataggioInCorso(true)
        try {
            await onSalvaNota(i, nota)
            setAlertSalvataggio(false)
        } catch (err) {
            setAlertSalvataggio(err.message)
        } finally {
            setSalvataggioInCorso(false)
        }
    }

    const {
        inputClassesNOW
    } = stilePulsanti

    if (!(i % 2 == 0)) {
        className = className+'  sfondoColChiaro'
    }

    if (!arrLength) {
        arrLength = 1
    }

    function toDate(stringDate) {
        if (stringDate) {
            var d = new Date(stringDate),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        } else {
            return null
        }
    }

    const notaDef = function(padding) {
        if (handleChange) { return(
            <div className={className+ " items-center flex flex-wrap justify-between pa2 br4 mb3 "+padding}>
                <div className="w-10">
                <img
            src={pathImmagine}
            className="br-100 dib"
            alt="foto utente"></img>
                </div>
                <div className="w-80 pl4 pr2">
                <p>{toDate(nota.dataNota)}</p>
                <div className="mb3"><strong>{nomeDisplay}</strong> dice:</div>
                {notaModificabile
                ? <textarea
                            type="text"
                            rows="5"
                            id="noteRimb"
                            name={i === -1 ? "WIP nome nota" : "noteArr["+i+']["contenuto"]'}
                            value={nota.contenuto}
                            onChange={handleChange}
                            className={inputClassesNOW + " w-100"} />
                : <p>{nota.contenuto}</p>                }
                
                </div>       
                {alertSalvataggio && <div className="w-100 colAnnullato">{alertSalvataggio}</div>}
                                    {/* FINE GROSSO CASINO DEI BOOLEAN */}
                {puoEliminare && <div className='w-10 material-icons dim br-100 bordoColAlt pointer tr' onClick={() => setConferma(!conferma)}>delete</div>}
                {mostraSalvaNota && (
                    <div className="w-100 tr mt2">
                        <button
                            className={stilePulsanti.buttonClassesGreen}
                            disabled={salvataggioInCorso || !String(nota.contenuto || "").trim()}
                            onClick={salvaNota}
                        >
                            {salvataggioInCorso ? "Salvataggio..." : "Salva nota"}
                        </button>
                    </div>
                )}
            </div>
        )} else {
            return(
                <div className={className+ " items-center flex flex-wrap justify-between pa2 br4 mb3 "+padding}>
                    <div className="w-10">
                    <img
                src={pathImmagine}
                className="br-100 dib"
                alt="foto utente"></img>
                    </div>
                    <div className="w-80 pl4 pr2">
                    <p>{toDate(nota.dataNota)}</p>
                    <div className="mb3"><strong>{nomeDisplay}</strong> dice:</div>
                    <p>{nota.contenuto}</p> </div>              
                </div>
            )
        }
    }

    const eliminaNota = async function() {
        if (bozzaNota) {
            setConferma(false);
            rimuoviBozza(i);
            return
        }
        if (notaPropria && canScrivereNote) {
            try {
                await onEliminaNota(i, nota)
                setConferma(false)
            } catch (err) {
                setAlertSalvataggio(err.message)
            }
            return
        }
        if(!canUpdateLogistica) {
            return
        }
        if (nota.id) {
            if (!token) {
                setAlertSalvataggio("Token non disponibile")
                return
            }
            const data = {
                idDaCancellare: [
                  {tabella: tabellaNote,
                  dato: `id`,
                  valore: nota.id}
                  ]
              }
              const config = {
                  headers: {
                      Authorization: "Bearer " + token,
                    }
              }
              try {
                  const res = await axios.patch(apiUrl + "/logistica/ordine/deleteIDconFeedback", data, config)
                  if (res.data.risultati) {
                      setConferma(false);
                      rimuoviDaArr("noteArr",i);
                  } else if (res.data.err) {
                      setAlertSalvataggio(res.data.err);
                  } else if (res.data.error) {
                      setAlertSalvataggio(res.data.error);
                  }
              } catch (err) {
                  setAlertSalvataggio(err.response?.data?.error || err.message)
              }
        } else {
            setConferma(false);
            rimuoviDaArr("noteArr",i);
        }
    }
    
    if (conferma && puoEliminare) {
        return(
            <div className={className+" w-100 ba bordoColAlt br4 tc pa4 mb3"}>
                <div className="mb3 b">Cancellare questa nota?</div>
                {bozzaNota
                    ? <div className="mb3">La nota non è ancora stata salvata.</div>
                    : <div className="mb3">La cancellazione sarà <strong>immediata e irreversibile.</strong></div>}
                <button className={stilePulsanti.buttonClassesRed + " mb2"} onClick={eliminaNota}>Sì</button>
                <button className={stilePulsanti.buttonClassesWhite + " mb2"} onClick={() => setConferma(!conferma)}>No</button>
            </div>
        )
    } else {
        return (
        <div>
            <div className="dn db-ns">
                {notaDef("pl4 pr4")}
            </div>  
            <div className="db dn-ns dn-m">
                {notaDef("")}
            </div>  
        </div>
        )
    }
}

export default Nota;



